module.exports = __webpack_public_path__ + "img/query.9d0ab441.png";